import { NgModule } from '@angular/core';
import { ShipLabelComponent } from './ship-label.component';
import { MatButtonModule } from '@angular/material/button';
import { SafeStringModule } from '../../pipes/safe-string/safe-string.module';

@NgModule({
  imports: [
    MatButtonModule,
    SafeStringModule,
  ],
  declarations: [ShipLabelComponent],
  providers: [],
  exports: [ShipLabelComponent],
})
export class ShipLabelModule {
}
